<div class="match-card" fxFlex="column" [ngClass]="{'ongoing-match': match.onGoing}" style="cursor:pointer;" [routerLink]="index">
    <div class="match-card-head" *ngIf="!match.onGoing"><strong>{{match.matchDate | date}}</strong></div>
    <div class="match-card-head" *ngIf="match.onGoing" style="color: red;"><strong>Playing Now</strong></div>
    <div class="match-card-body">
        <div fxFlex="row">
            <app-team [team]="match.winnerTeam" fxFlex="50"></app-team>
            <app-team [team]="match.loserTeam" fxFlex="50"></app-team>
        </div>
    </div>
</div>